import request from "./../utils/request";

export function listChannels() {
    return request({
        url: `/channel/list`,
        method: "get",
        params: {},
    });
}

export function createChannel(
    type,
    name,
    chatbotStory,
    payload,
    visibility = {
        users: [],
        departments: [],
    }
) {
    return request({
        url: "/channel",
        method: "put",
        data: {
            type,
            name,
            chatbotStory,
            payload,
            visibility,
        },
    });
}

export function updateChannel(id, name, enabled, chatbotStory, payload, visibility = { users: [], departments: [] }) {
    return request({
        url: `/channel/${id}`,
        method: "post",
        data: {
            chatbotStory,
            name,
            enabled,
            payload,
            visibility,
        },
    });
}

export function deleteChannel(id) {
    return request.delete(`/channel/${id}`);
}
